/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/56949300
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import equals from 'ramda/src/equals';
// import { withRouter } from 'react-router-dom'
import Col from 'react-bootstrap/Col';
import { toast } from 'react-toastify';
import isEmpty from 'ramda/src/isEmpty';
import Row from 'react-bootstrap/Row';
import moment from 'moment';
import Accordion from '@components/@core/Accordion';
import Button from '@components/@core/AnimatedButton';
import Settings from '@components/@core/Settings';
import Dropdown from '@components/@core/Dropdown';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import Input from '@components/@core/Input';
import { QUOTA_DIRECTIONS, QUOTA_FORECASTING, QUOTA_VALUES } from '~/services/constants';

class Edit extends Component {
    state = {
        id: this.props.data.id,
        title: this.props.data.name,
        description: this.props.data.data.description,
        selected: {
            author: this.props.data.author_id ? [this.props.data.author_id] : null,
            department: this.props.data.data.department,
            competency: this.props.data.data.competency,
            category: this.props.data.data.category,
            forecasting: [this.props.data.quota_forecasting ?? 0],
            quotaValue: [this.props.data.quota_value ?? 1],
            direction: [this.props.data.quota_direction ?? 1],
        },
        disabled: true,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { data } = nextProps;
        const { title, description, selected } = prevState;
        const disabled =
            data.name === title &&
            data.data.description === description &&
            equals(selected.author, [data.author_id]) &&
            equals(selected.department, data.data.department ?? []) &&
            equals(selected.competency, data.data.competency ?? []) &&
            equals(selected.category, data.data.category ?? []) &&
            equals(selected.quotaValue[0], data.quota_value) &&
            equals(selected.direction[0], data.quota_direction);
        return { disabled };
    }

    handleSelectTags = (key) => (tags) => {
        const { selected } = this.state;
        if (!equals(selected[key], tags)) {
            selected[key] = tags;
            this.setState({ selected });
        }
    };

    handleSubmit = (published) => () => {
        const { id, title, description, selected } = this.state;

        if (isEmpty(title) || isEmpty(description)) {
            toast.error(`Title and Description are required.`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }
        const data = {
            quota_template: {
                id,
                name: title,
                data: {
                    description,
                    category: selected.category,
                    competency: selected.competency,
                    department: selected.department,
                },
                author_id: selected.author[0],
                quota_direction: selected.direction[0],
                quota_forecasting: selected.forecasting[0],
                quota_value: selected.quotaValue[0],
                published,
            },
        };
        const pathName = this.props.location?.pathname || window.location.pathname;
        const payload = {
            type: 'quotas',
            baseUrl: pathName.includes('to-do') ? '' : pathName,
            data,
        };
        this.props.onUpdate(payload);
    };

    render() {
        const { title, description, selected, disabled } = this.state;
        const { data, authors, departments, userRole, competencies, categories, onSelect } = this.props;
        const { published } = data;
        const settings = [
            { name: 'Author', id: selected.author, options: authors, select: 'author' },
            { name: 'Departments', id: selected.department, options: departments, select: 'department' },
            { name: 'Competencies', id: selected.competency, options: competencies, select: 'competency' },
            { name: 'Categories', id: selected.category, options: categories, select: 'category' },
        ];
        const stats = [
            { name: 'Created', value: moment(data?.created_at).format('MMM DD, YY') || null },
            { name: 'Created By', value: data?.created_by || 'N/A' },
            { name: 'Last Edited', value: moment(data?.updated_at).format('MMM DD, YY') || null },
            { name: 'Last edits by', value: data?.edited_by || 'N/A' },
            { name: 'Assigned', value: data?.assigned || 'N/A' },
        ];

        return (
            <>
                <Filter back="all quotas" />
                <div className="lib-todo-quota" data-cy="editQuotaForm">
                    <div className="quota-detail">
                        <div className="section">
                            <div className="d-h-between mb-3">
                                <p className="dsl-b16 bold mb-0">Goal</p>
                                <div className="d-h-end cursor">{userRole < 3 && <EditDropdown dataCy="editDropdown" options={['Detail View']} onChange={onSelect} />}</div>
                            </div>
                            <div className="object-title">
                                <Input className="input-field heading mb-2" title="Name" type="text" value={title} placeholder="Type here..." onChange={(title) => this.setState({ title })} />
                            </div>
                            <Input
                                title="Description"
                                className="input-field description mb-3"
                                type="text"
                                dataCy="description"
                                as="textarea"
                                rows="3"
                                value={description}
                                placeholder="Type here..."
                                onChange={(description) => this.setState({ description })}
                            />
                            <Dropdown
                                className="dropdown-field mb-2"
                                title="Type"
                                width="fit-content"
                                defaultIds={data ? selected.quotaValue : null}
                                data={QUOTA_VALUES}
                                getValue={(e) => e.name}
                                onChange={this.handleSelectTags('quotaValue')}
                            />
                            <Dropdown
                                className="dropdown-field mb-2"
                                title="Direction of Scale"
                                width="fit-content"
                                defaultIds={data ? selected.direction : null}
                                data={QUOTA_DIRECTIONS}
                                getValue={(e) => e.name}
                                onChange={this.handleSelectTags('direction')}
                            />
                            <Dropdown
                                className="dropdown-field mb-3"
                                title="Calculation for forcast"
                                width="fit-content"
                                defaultIds={data ? selected.forecasting : null}
                                data={QUOTA_FORECASTING}
                                getValue={(e) => e.name}
                                onChange={this.handleSelectTags('forecasting')}
                            />
                        </div>
                    </div>

                    <Settings expanded isEditable values={settings} stats={stats} handleSelect={this.handleSelectTags} />
                    <div className="btn-wrapper mt-3 d-h-end">
                        <Button disabled={disabled && published !== 1} className="mr-3" name="Draft" type="low" onClick={this.handleSubmit(0)} />
                        <Button disabled={disabled && published !== 0} name="Publish" onClick={this.handleSubmit(1)} />
                    </div>
                </div>
            </>
        );
    }
}

Edit.propTypes = {
    data: PropTypes.any,
    name: PropTypes.string,
    description: PropTypes.string,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
    courses: PropTypes.array,
    onUpdate: PropTypes.func,
};

Edit.defaultProps = {
    quota: {},
    id: null,
    name: '',
    description: '',
    departments: [],
    competencies: [],
    categories: [],
    courses: [],
    onUpdate: () => {},
};

export default Edit;
